<template>
  <div class="edyst-form-group email-editor-container">
    <h3 class="font-bold text-center">
      {{ editMode ? "Update" : "Create" }} Email Template
    </h3>
    <label for="name" class="font-bold"
      >Name
      <small class="err-msg text-red mt-2">
        {{ veeValidateErrors.first("name") }}
      </small></label
    >
    <input
      id="name"
      ref="templateName"
      v-model="template.name"
      v-validate="'required'"
      name="name"
      placeholder="Enter template name"
      type="text"
      class="template-name"
      style="margin-top: 0;"
    />

    <label for="subject" style="padding-top:10px;" class="font-bold"
      >Subject
      <small class="err-msg text-red my-2">
        {{ veeValidateErrors.first("subject") }}
      </small></label
    >
    <input
      id="subject"
      ref="subject"
      v-model="template.content.subject"
      v-validate="'required'"
      name="subject"
      placeholder="Enter email subject"
      type="text"
      class="template-subject"
      style="margin-top: 0;"
    />

    <label for="body" class="font-bold" style="padding-top:10px;"
      >Email body
    </label>

    <div
      id="body"
      ref="myQuillEditor"
      name="body"
      class="email-editor w-full h-1/5 mt-2"
      :options="quillEditorOptions"
    ></div>
    <div class="flex items-center justify-end mt-2 action-buttons">
      <button
        class="px-4 ml-2 bg-grey-dark text-white font-normal rounded-sm py-2"
        @click.prevent="$emit('discard-sms-modal')"
      >
        Cancel
      </button>
      <button
        class="px-4 ml-2 bg-green text-white font-normal rounded-sm py-2"
        @click.prevent="handleSubmit"
      >
        {{ editMode ? "Update" : "Save" }}
      </button>
    </div>
  </div>
</template>

<script>
import Quill from "quill"
import "quill/dist/quill.core.css"
import "quill/dist/quill.snow.css"
import "quill/dist/quill.bubble.css"
import setupImageUpload from "@/utils/quillEditorImageUploadHelper"
import {
  createTemplate,
  updateTemplate,
  getTemplate,
} from "@/apis/notification/index"

export default {
  props: {
    editTemplateObj: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loader: null,
      quillInstance: null,
      notyConfig: {
        layout: "bottomLeft",
        animation: {
          open: "slideUp",
          close: "fadeOut",
          progressBar: false,
        },
      },
      template: {
        name: "",
        channel_type: 2,
        content: {
          body: "",
          subject: "",
        },
      },
      quillEditorOptions: {
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, 4, false] }],
            ["bold", "italic", "underline", "strike"],
            [{ list: "ordered" }, { list: "bullet" }],
            [{ script: "sub" }, { script: "super" }],
            ["blockquote", "code-block"],
            [{ indent: "-1" }, { indent: "+1" }],
            ["clean"],
          ],
        },
        placeholder: "Start designing your email...",
        readOnly: false,
        theme: "snow",
      },
    }
  },
  computed: {
    editMode() {
      return !!(this.editTemplateObj && this.editTemplateObj.name)
    },
  },
  created() {
    if (this.editMode) {
      this.template.name = this.editTemplateObj.name
      this.fetchTemplateContent(this.editTemplateObj.id)
    }
    setupImageUpload(this.quillEditorOptions)
  },
  mounted() {
    this.quillInstance = new Quill(
      this.$refs.myQuillEditor,
      this.quillEditorOptions
    )
    this.quillInstance.on("text-change", () => {
      this.template.content.body = this.quillInstance.root.innerHTML
    })
    this.$refs.templateName.focus()
  },
  methods: {
    async handleSubmit() {
      const result = await this.$validator.validateAll()
      if (!result) {
        this.$noty.error("Please fix the errors and try again", this.notyConfig)
        return
      }
      if (this.editMode) {
        this.editTemplate()
      } else {
        this.createEmailTemplate()
      }
    },
    fetchTemplateContent(id) {
      this.loader = this.$loading.show({
        loader: "bars",
      })
      getTemplate(id)
        .then(res => {
          this.template = res.data
          // populate quill editor
          this.quillInstance.root.innerHTML = res.data.content.body
        })
        .catch(err => {
          console.error(err)
          this.$noty.error(`Failed to get Email content`, this.notyConfig)
        })
        .finally(() => {
          if (this.loader) {
            this.loader.hide()
          }
        })
    },
    createEmailTemplate() {
      createTemplate(this.template)
        .then(() => {
          this.$noty.info(`New Email template created`, this.notyConfig)
          this.$modal.hide("email-modal")
          this.$emit("template-created")
        })
        .catch(err => {
          console.error(err)
          this.$noty.error(`Failed to create Email template`, this.notyConfig)
        })
    },
    editTemplate() {
      this.loader = this.$loading.show({
        loader: "bars",
      })
      updateTemplate(this.editTemplateObj.id, this.template)
        .then(() => {
          this.$noty.info(`Template updated`, this.notyConfig)
          this.$modal.hide("email-modal")
          this.$emit("template-created")
        })
        .catch(err => {
          console.error(err)
          this.$noty.error(`Failed to update template`, this.notyConfig)
        })
        .finally(() => {
          if (this.loader) {
            this.loader.hide()
          }
        })
    },
  },
}
</script>

<style scoped>
.action-buttons {
  position: absolute;
  top: 0.5rem;
  right: 1.5rem;
}

.email-editor-container {
  overflow: auto;
  height: calc(100% - 1rem);
  padding: 1.5rem;
  padding-top: 2rem;
}

.edyst-form-group .email-text {
  width: 100%;
  height: 8rem;
}

.edyst-form-group .email-text,
.edyst-form-group .template-name,
.edyst-form-group .template-subject {
  margin: 0;
  color: #5c5c5c;
}

.email-editor {
  height: calc(100% - 15rem);
}

.err-msg {
  font-weight: normal;
}
</style>
